export const dynamicGridImageConfig = {
  smSize: { width: 320, height: 400 },
  mdSize: { width: 564, height: 705 },
  lgSize: { width: 704, height: 880 },
  xlSize: { width: 828, height: 1035 },
};
